export default __webpack_public_path__ + "static/media/strikethrough.b06ce8da.svg";